import { FC } from 'react';
import { Control, Controller, DeepMap, FieldError } from 'react-hook-form';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';

import Input from '@/components/form-elements/input';
import getVariablePlainText from '@/lib/get-variable-plain-text';
import useVariables from '@/lib/hooks/use-variables';
import { LotteryFormData } from '@/lib/lottery2';
import {
  defaultPhoneCountry,
  phoneCountries,
} from '@/lib/participant-field-options';

import { Field } from '..';

interface PhoneProps {
  control: Control<LotteryFormData>;
  errors: DeepMap<LotteryFormData, FieldError>;
  field: Field;
}

const Phone: FC<PhoneProps> = ({ control, errors, field }) => {
  const variables = useVariables();
  const { name, label } = field;

  return (
    <div className="flex flex-col">
      <label htmlFor={name} className="text-overline mb-2">
        {label}
      </label>

      <Controller
        name={name}
        control={control}
        rules={{ required: true, validate: isValidPhoneNumber }}
        render={({ field: controllerField }) => (
          <PhoneInput
            {...controllerField}
            inputComponent={Input}
            defaultCountry={defaultPhoneCountry}
            withCountryCallingCode
            international
            countryCallingCodeEditable={false}
            countries={phoneCountries}
          />
        )}
      />

      {errors?.[name] && (
        <span className="text-red-medium text-small mt-1">
          {getVariablePlainText(variables['form-phone-error-text'])}
        </span>
      )}
    </div>
  );
};

export default Phone;
